// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error .error_inner{padding:50px 20px 50px}.error_inner .error_subtitle.mtop{margin-top:20px}.error_inner .error_subtitle.mtop a{color:rgba(76,118,161,.9)}.error_inner .error_subtitle.mtop a:hover{color:rgba(255,68,0,.9)}", ""]);
// Exports
module.exports = exports;
